import React from 'react';
import { ILinkMessage } from './types';
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';

export function LinkMessage({
	message,
	className,
}: {
    message: ILinkMessage;
    className: string;
}): JSX.Element {
	return (
		<LocalizedLink
			to={message.link}
			target="_blank"
			reloadDocument
			className={className}
		>
			{message.text}
		</LocalizedLink>
	);
}
